
















import Vue from 'vue';
import { mapActions } from 'vuex';
import DocumentTypeConfiguration from '@/components/configuration/cabinet/DocumentTypeConfiguration.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import {
  EditMode,
  CabinetConfigurationModel,
  DocumentTypeConfigurationModel,
  ReferenceConfigurationModel,
  CabinetReferenceType,
  StoreReferenceConfigurationModel,
  DocumentTypeConfigurationModelDefaults,
  CabinetReferenceConfigurationModel,
  StoreReferenceConfigurationModelDefaults,
  SearchReferenceConfigurationModelDefaults,
  StoreConstants
} from '@/types';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import { CabinetConfigurationHelper } from '@/mixins';
import { ObjectUtils } from '@/utils/objectUtils';
import { DocumentTypeEncryptionEnabledType } from '@/types/enums/DocumentTypeEncryptionEnabledType';

export default Vue.extend({
  mixins: [CabinetConfigurationHelper],
  data() {
    return {
      cabinetConfiguration: {} as CabinetConfigurationModel,
      newDocumentTypeConfiguration: {} as DocumentTypeConfigurationModel,
      submitting: false,
      isLoading: true
    };
  },
  methods: {
    ...mapActions('configurationStore', ['getConfigurationTree', 'setSelectedNodeToExpandOnMount']),
    ...mapActions(StoreConstants.CabinetConfiguration.ModuleName, [StoreConstants.CabinetConfiguration.Actions.GetCabinetConfigurationSettingsWithErrorPage]),
    async getCabinetConfigurationSettingsAsync(this: any) {
      await this.getCabinetConfigurationSettingsWithErrorPage();
    },
    async onSubmitAsync(this: any, cabinetConfiguration: CabinetConfigurationModel) {
      this.submitting = true;
      try {
        const newCabinet = await CabinetConfigurationService.createDocumentTypeAsync(cabinetConfiguration);
        await this.getConfigurationTree();
        this.setSelectedNodeToExpandOnMount();
        this.navigateToCabinetDashboard(newCabinet.id);
      } catch (error) {
        this.$log(error);
      } finally {
        this.submitting = false;
      }
    },
    async getCabinetConfigurationAsync(this: any) {
      try {
        this.cabinetConfiguration = await CabinetConfigurationService.getCabinetConfigurationWithErrorPageAsync(this.$route.params.cabinetId);
        this.createNewDocumentTypeConfiguration();
      } catch (error) {
        this.$log(error);
      }
    },
    getExistingCabinetStoreReferenceConfigurationOrDefault(this: any, cabinetReference: CabinetReferenceConfigurationModel) {
      let referenceConfiguration = this.cabinetConfiguration.defaultCommonStoreReferencesConfiguration.find(
        (ref: StoreReferenceConfigurationModel) => ref.referenceNumber === cabinetReference.referenceNumber
      );
      if (!referenceConfiguration) {
        referenceConfiguration = {
          ...StoreReferenceConfigurationModelDefaults,
          referenceNumber: cabinetReference.referenceNumber
        };
      }
      referenceConfiguration.useDefaults = true;
      referenceConfiguration.lookup = false;
      return referenceConfiguration;
    },
    getCabinetSearchReferenceConfiguration(this: any, cabinetReference: CabinetReferenceConfigurationModel) {
      return { ...SearchReferenceConfigurationModelDefaults, referenceNumber: cabinetReference.referenceNumber };
    },
    createNewDocumentTypeConfiguration(this: any) {
      const storeReferenceConfigurations = this.cabinetReferences.map((reference: CabinetReferenceConfigurationModel) => ({
        key: reference.key,
        referenceType: CabinetReferenceType.Common,
        referenceNumber: reference.referenceNumber,
        storeReferenceConfiguration: this.getExistingCabinetStoreReferenceConfigurationOrDefault(reference),
        searchReferenceConfiguration: this.getCabinetSearchReferenceConfiguration(reference)
      })) as ReferenceConfigurationModel[];

      this.newDocumentTypeConfiguration = {
        ...DocumentTypeConfigurationModelDefaults,
        referencesConfiguration: storeReferenceConfigurations
      };
      this.newDocumentTypeConfiguration.encryptionEnabled = this.cabinetConfiguration.isEncryptNewDocumentTypesEnabled
        ? DocumentTypeEncryptionEnabledType.EnabledForNewDocuments
        : DocumentTypeEncryptionEnabledType.Disabled;
    },
    onCancel(this: any) {
      this.navigateToCabinetDashboard(this.cabinetConfiguration.id);
    }
  },
  computed: {
    cabinetReferences(this: any) {
      return this.cabinetConfiguration.cabinetReferences.filter((cabRef: CabinetReferenceConfigurationModel) => cabRef.referenceType === CabinetReferenceType.Common);
    },
    documentTypeConfigurationLoaded(this: any) {
      return !ObjectUtils.isNullOrEmpty(this.newDocumentTypeConfiguration);
    }
  },
  async mounted(this: any) {
    await this.getLock();
    await this.getCabinetConfigurationAsync();
    await this.getCabinetConfigurationSettingsAsync();
    this.isLoading = false;
  },
  created(this: any) {
    this.EDIT_MODE = EditMode.Add;
    this.$route.meta.treePath = `/configuration/cabinet/${this.$route.params.cabinetId}/dashboard`;
  },
  beforeDestroy(this: any) {
    this.$route.meta.treePath = null;
  },
  components: {
    DocumentTypeConfiguration,
    LoadingSpinner
  }
});
